export default {
    props: {
        activeCell: {
            type: String,
            default: undefined,
            kComposite: 'activeCell'
        }, 
        name: {
            type: String,
            default: undefined,
            kComposite: 'name'
        }, 
        columns: {
            type: Array,
            default: undefined,
            kComposite: 'columns'
        },
        dataSource: {
            type: [Object, Array],
            default: undefined,
            kComposite: 'dataSource'
        }, 
        dataSourceRef: {
            type: String,
            default: undefined,
            kComposite: 'dataSourceRef'
        }, 
        filterColumns: {
            type: Array,
            default: undefined,
            kComposite: 'filter.columns'
        },
        filterRef: {
            type: String,
            default: undefined,
            kComposite: 'filter.ref'
        }, 
        frozenColumns: {
            type: Number,
            default: undefined,
            kComposite: 'frozenColumns'
        }, 
        frozenRows: {
            type: Number,
            default: undefined,
            kComposite: 'frozenRows'
        }, 
        mergedCells: {
            type: Array,
            default: undefined,
            kComposite: 'mergedCells'
        }, 
        rows: {
            type: Array,
            default: undefined,
            kComposite: 'rows'
        },
        selection: {
            type: String,
            default: undefined,
            kComposite: 'selection'
        }, 
        showGridLines: {
            type: Boolean,
            default: undefined,
            kComposite: 'showGridLines'
        }, 
        sortColumns: {
            type: Array,
            default: undefined,
            kComposite: 'sort.columns'
        },
        sortRef: {
            type: String,
            default: undefined,
            kComposite: 'sort.ref'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-spreadsheet-vue-wrapper/src/KendoSpreadsheetSheet/SheetProps.js